import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';
import { fetchUsers } from '../Users/usersThunk';

const initialState = {
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  serviceWorkerRegistration: null,
  isFetchingUsers: false,
  fetchUsersError: null,
  usersList: [],
  usersMap: {},
};

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    serviceWorkerInit: (state) => {
      state.serviceWorkerInitialized = !state.serviceWorkerInitialized;
    },
    serviceWorkerUpdate: (state, action) => {
      state.serviceWorkerUpdated = !state.serviceWorkerUpdated;
      state.serviceWorkerRegistration = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isFetchingUsers = true;
        state.fetchUsersError = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isFetchingUsers = false;
        state.fetchUsersError = null;
        state.usersList = action.payload;
        state.usersMap = keyBy(action.payload, 'id');
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.isFetchingUsers = false;
        state.fetchUsersError = 500;
      });
  },
});

export const { serviceWorkerInit, serviceWorkerUpdate } = userSlice.actions;

export default userSlice.reducer;
